// extracted by mini-css-extract-plugin
export default {"savedBadge":"SavedBadge_savedBadge__8R1-K","icon":"SavedBadge_icon__OS95m"};